import React, { useState } from 'react';
import {useRsvp} from "../context/RsvpContext";
import { FaArrowRight } from 'react-icons/fa6';
import Alert from "./Alert";
import CustomButton from "./CustomButton";
import RSVPApiService from "../services/rsvpApiService";

interface Viaje {
    checked: boolean;
    disabled: boolean;
}

const TransportComponent = () => {
    const {rsvp, setRsvp} = useRsvp();
    const [saving, setSaving] = useState(false);
    const [numPass, setNumPass] = useState(rsvp?.pasajeros_para_transporte || 0);
    const [selectedViajes, setSelectedViajes] = useState<Viaje[]>([
        {checked: rsvp?.viernes_ida || false, disabled: false},
        {checked: rsvp?.sabado_ida || false, disabled: false},
        {checked: rsvp?.sabado_regreso || false, disabled: false},
        {checked: rsvp?.domingo_regreso || false, disabled: false},
    ]);
    const [message, setMessage] = useState<string | null>(null);
    const [messageType, setMessageType] = useState<'success' | 'error' | 'info' | 'warning'>('success');

    const opcionesViajes = [
        { name: "Viernes 20 Marzo", from: "CDMX", to: "Tres Marías"},
        { name: "Sábado 21 Marzo", from: "CDMX", to: "Tres Marías"},
        { name: "Sábado 21 Marzo", from: "Tres Marías", to: "CDMX"},
        { name: "Domingo 22 Marzo", from: "Tres Marías", to: "CDMX"}
    ];

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!rsvp) return;
        setSaving(true);
        setMessage(null);
        try {
            const updated = {
                ...rsvp,
                pasajeros_para_transporte: numPass,
                viernes_ida: selectedViajes[0].checked,
                sabado_ida: selectedViajes[1].checked,
                sabado_regreso: selectedViajes[2].checked,
                domingo_regreso: selectedViajes[3].checked
            };
            const rsvpApiService = RSVPApiService;
            const updatedRsvp = await rsvpApiService.updateRSVP(updated);
            setRsvp(updated);
            sessionStorage.setItem('rsvp', JSON.stringify(updatedRsvp));
            setMessage('¡Gracias! Tu selección de transporte fue guardada.');
            setMessageType('success');
        } catch (e: any) {
            setMessage('Ocurrió un error al guardar. Intenta más tarde.');
            setMessageType('error');
        } finally {
            setSaving(false);
        }
    };

    const handlePassengers = (numb: number) => {
        setNumPass(numb);
    };

    const handleViaje = (e: React.ChangeEvent<HTMLInputElement>) => {
        // e.preventDefault();
        const newIndex = parseInt(e.target.value);
        if (!rsvp) return;
        const viajes = [...selectedViajes];
        viajes[newIndex].checked = !viajes[newIndex].checked;
        if (viajes[0].checked){
            viajes[1].checked = false;
            viajes[1].disabled = true;
        } else {
            viajes[1].disabled = false;
        }
        if (viajes[1].checked){
            viajes[0].checked = false;
            viajes[0].disabled = true;
        } else {
            viajes[0].disabled = false;
        }
        if (viajes[2].checked){
            viajes[3].checked = false;
            viajes[3].disabled = true;
        } else {
            viajes[3].disabled = false;
        }
        if (viajes[3].checked){
            viajes[2].checked = false;
            viajes[2].disabled = true;
        } else {
            viajes[2].disabled = false;
        }
        setSelectedViajes(viajes);
    }

    const guests = (rsvp?.allowedGuests ?? 0) + 1;

    return (
        <div className="min-h-lvh relative mt-10">
            <div className="flex flex-col justify-center items-center text-white">
                <p className="text-center">Si estás interesadx en la contratación de transporte privado (tipo van) para viaje sencillo o redondo y compartir con otros de nuestros invitados, por favor llena el siguiente formulario:</p>
                <form onSubmit={handleSubmit} className="mt-8">
                    <div className="bg-[#f2ece7] rounded-[40px] p-6 text-[#606060]">
                        <p className="text-center font-bold text-lg">Registro para transporte</p>
                        <div className="mt-4">
                            <label htmlFor="num-passengers">Número de pasajeros:</label>
                            <select
                                id="num-passengers"
                                value={numPass}
                                onChange={(e) => handlePassengers(parseInt(e.target.value))}
                                className="flex-initial rounded-lg px-2 focus:ring-2 focus:ring-orange-500 focus:border-transparent text-[#606060] bg-white ml-2"
                            >
                                {Array.from({length: guests}, (_, i) => i).map(
                                    num => (
                                        <option key={num} value={num}>{num}</option>
                                    )
                                )}
                            </select>
                        </div>
                        <p className="italic mt-2">Selecciona el número de viajes que te interesaría contratar:</p>
                        <div className="grid grid-cols-1 gap-4 mt-4 justify-items-center">
                            {opcionesViajes.map(((viaje, idx) => (
                                <div key={viaje.name + idx.toString()} className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id={viaje.name + idx.toString()}
                                        value={idx}
                                        name="viaje"
                                        checked={selectedViajes[idx].checked}
                                        disabled={selectedViajes[idx].disabled}
                                        onChange={handleViaje}
                                        className="bg-white/20 rounded-xl shadow-xl"
                                    />
                                    <label htmlFor={viaje.name + idx.toString()} className="ml-2"><p className="font-bold">{viaje.name}</p><span className="flex items-center gap-2 text-sm">{viaje.from}{FaArrowRight({})}{viaje.to}</span></label>
                                </div>
                            )))}
                        </div>
                        <div className="mt-6 w-full">
                            {message && <Alert
                                severity={messageType}
                                onClose={() => setMessage(null)}
                                className="shadow-sm mb-4"
                            >
                                {message}
                            </Alert>}
                            <div className="flex justify-center">
                                <CustomButton
                                    type="submit"
                                    text={saving ? 'GUARDANDO...' : 'ENVIAR'}
                                    disabled={saving}
                                    rounded={'rounded-full'}
                                    bgColor={'bg-(--hover-color)'}
                                    hoverColor={'hover:bg-(--primary-color)'}
                                    className="font-bold"
                                />
                            </div>
                        </div>
                    </div>
                </form>
                <p className="text-center mt-8">Cuando estemos más cercanos a la fecha del evento, nos pondremos en contacto contigo para proporcionarte más información.</p>
                <img src={"/images/Grid-Transporte%20-%20Copy.png"} alt={"Hospedaje"} className="mt-20 mb-20"/>
            </div>
        </div>
    );
};

export default TransportComponent;